import React from "react";
import usePageMeta from "@/hooks/usePageMeta";
import { useI18n } from "@/i18n";
import Hero from "@/components/sections/Hero";
import Story from "@/components/sections/Story";
import Hosts from "@/components/sections/Hosts";
import Atmosphere from "@/components/sections/Atmosphere";
import Booking from "@/components/sections/Booking";

export default function Home() {
  const { t } = useI18n();
  usePageMeta(t.meta.home.title, t.meta.home.desc);
  return (
    <>
      <Hero />
      <Story />
      <Hosts />
      <Atmosphere />
      <Booking />
    </>
  );
}
